import React from "react";
import { motion } from "framer-motion";

export function PageHeader({ eyebrow, title, italic, tail, subtitle, children }) {
  return (
      <section className="relative pt-40 pb-20 md:pb-24 border-b border-ivory-300">
      <img
        aria-hidden
        src="https://images.unsplash.com/photo-1705837863332-7162639852d8?crop=entropy&cs=srgb&fm=jpg&w=1600&q=60"
        className="absolute inset-0 w-full h-full object-cover opacity-[0.12] mix-blend-multiply pointer-events-none"
        alt=""
      />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-9">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs uppercase tracking-[0.3em] text-saffron">{eyebrow}</span>
            <h1 className="mt-4 font-serif tracking-tighter leading-[0.95] text-ink text-[3rem] sm:text-[4rem] md:text-[5rem] lg:text-[6rem]">
              {title}{" "}
              {italic && <span className="italic text-tulsi">{italic}</span>}
              {tail && <> {tail}</>}
            </h1>
            {subtitle && (
              <p className="mt-6 max-w-3xl text-ink-50 text-lg md:text-xl font-light leading-relaxed">
                {subtitle}
              </p>
            )}
            {children}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
